module.exports = __webpack_public_path__ + "static/media/role.8bcfb0c8.svg";